import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { retrySapMigration } from '../../../../actions';

const SapMigrationRetryButton = ({
  depositId,
  liquidationId,
  documentType,
  title,
  dispatchRetrySapMigration,
}) => {
  const [loading, setLoading] = useState(false);

  const handleRetry = async () => {
    setLoading(true);
    await dispatchRetrySapMigration({ depositId, liquidationId, documentType });
    setLoading(false);
  };

  return (
    <Button
      size="sm"
      color="warning"
      onClick={handleRetry}
      disabled={loading}
      className="ml-1"
      style={{ padding: '2px 6px', fontSize: '0.75rem' }}
      title={title}
    >
      <i className="fa fa-refresh" />
    </Button>
  );
};

SapMigrationRetryButton.propTypes = {
  depositId: PropTypes.number.isRequired,
  liquidationId: PropTypes.number.isRequired,
  documentType: PropTypes.string,
  title: PropTypes.string,
  dispatchRetrySapMigration: PropTypes.func.isRequired,
};

SapMigrationRetryButton.defaultProps = {
  documentType: null,
  title: 'Reintentar migración SAP',
};

const mapDispatchToProps = {
  dispatchRetrySapMigration: retrySapMigration,
};

export default connect(null, mapDispatchToProps)(SapMigrationRetryButton);
